import { Dayjs } from "utils/dayjs"

import { Guid, IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel, Purpose } from "config/constants"
import { toDayjsWithoutTimezone } from "utils/utils"
import Address, { IAddressDto } from "./Address"
import { ReservationStatus } from "./Reservation"

export interface IGetAssetReservationPagedDto {
    id: Guid
    number: string
    status: ReservationStatus
    assetId?: Guid
    hasUserAssignment: boolean
    eventStart: string
    eventEnd?: string
    eventAddress?: IAddressDto
    purpose: Purpose
    customer: { name: string }
    comment?: string
    links?: IApiLink[]
}

export default class AssetReservationPaged {
    id: Guid
    number: string
    status: ReservationStatus
    assetId?: Guid
    hasUserAssignment: boolean
    eventStart?: Dayjs
    eventEnd?: Dayjs
    eventAddress?: Address
    purpose: Purpose
    customerName: string
    comment?: string
    linkGetReservationShippingOrders?: IApiLink

    constructor(dto: IGetAssetReservationPagedDto) {
        this.id = dto.id
        this.number = dto.number
        this.status = dto.status
        this.assetId = dto.assetId
        this.hasUserAssignment = dto.hasUserAssignment
        this.eventStart = toDayjsWithoutTimezone(dto.eventStart)
        this.eventEnd = dto.eventEnd ? toDayjsWithoutTimezone(dto.eventEnd) : undefined
        this.eventAddress = dto.eventAddress ? new Address(dto.eventAddress) : undefined
        this.purpose = dto.purpose
        this.customerName = dto.customer.name
        this.comment = dto.comment
        this.linkGetReservationShippingOrders = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.shippingOrder && lnk.rel === ApiLinkRel.all)
    }
}
